import React from 'react';

// Catches a failed lazy chunk (offline, flaky network, new deploy) so one
// section can't blank the whole page. Keeps the section's anchor in place.
class SectionErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    render() {
        if (!this.state.failed) return this.props.children;
        return (
            <section id={this.props.id} className='section' role='alert'>
                <div className='container'>
                    <p>This section couldn’t load, probably a network hiccup.</p>
                    <button type='button' className='btn' style={{ marginTop: 16 }} onClick={() => window.location.reload()}>
                        Reload the page
                    </button>
                </div>
            </section>
        );
    }
}

export default SectionErrorBoundary;
